import type { PublicPadFile } from "../shared";
import { FileRow } from "./FileRow";

export function FileSection({
  title,
  files,
  onDelete,
  onNotice,
}: {
  title: string;
  files: PublicPadFile[];
  onDelete: (fileId: string) => Promise<void>;
  onNotice: (message: string) => void;
}) {
  if (!files.length) return null;

  return (
    <section className="space-y-2">
      <h2 className="text-xs font-semibold uppercase text-neutral-500">{title}</h2>
      {files.map((file) => (
        <FileRow key={file.id} file={file} onDelete={onDelete} onNotice={onNotice} />
      ))}
    </section>
  );
}
